import {
  NavigationMode,
  NavigationModeType,
  NavigationThemeType,
} from "@phn/utility/constants";
import { sanitizeMode, sanitizeTheme } from "@phn/utility/navi-state";

export const constructThemeClass = function (
  mode: NavigationModeType,
  theme: NavigationThemeType,
): string {
  const sanitizedMode = sanitizeMode(mode);
  if (sanitizedMode === NavigationMode.navbar) {
    return NavigationMode.navbar;
  }

  const sanitizedTheme = sanitizeTheme(theme);
  return `${mode}_${sanitizedTheme}`;
};
